<template>
  <div
    @click="$emit('click')"
    :style="{ 'background-image': `url(${this.data.image})` }"
    class="
      relative
      bg-pink-600
      rounded-full
      flex
      justify-center
      items-center
      text-white
      font-semibold
      profile-user
      h-35-px
      w-36-px
      bg-cover	bg-no-repeat	bg-center	
      uppercase
    "
  >
    <span v-if="!this.data.image" class="text-white font-semibold uppercase">
      {{ this.data.people_first_name.charAt(0) }} {{ this.data.people_surnames.charAt(0) }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["SHOWSEARCHCART"]),
    ...mapGetters("getUser", ["GET_USER"]),
  },
 
  props: {
    data: {
      type: Object,
    },
    width: {
      default: "35px",
    },
    height: {
      default: "35px",
    },
    font: {
      type: Object,
    },
      
  },
  created(){

  },
  data() {
    return {
      imageData: "",
      first_name: "",
      surnames: "",
    };
  },
  mounted() {
    if (window.localStorage.getItem("isLogIn") === "true")
      this.$store.dispatch("auth/setStatusLogin", true);
  },
   
};
</script>

<style scoped>
.w-36-px {
  width: 36px;
}

.h-35-px {
  height: 35px;
}

.user_progress {
  position: absolute !important;
  right: 30px !important;
  top: 10px !important;
}
</style>
